import KunLoading103 from './src/index'

KunLoading103.install = function (Vue) {
	Vue.component(KunLoading103.name, KunLoading103);
}

export default KunLoading103;
